import { Link } from 'react-router';

import AirkeyLogo from '../../assets/airkey-logo-white.svg?react';
import { EXTERNAL_URLS } from '../../constants';
import { Button } from '../Button';

import './Footer.scss';
import { footerLinks } from './footer-links';

// create footer link sections from the footerLinks array
const footerLinkSections = footerLinks.map((section) => (
  <div className="footer-top-links-section" key={section.title}>
    <h2 className="footer-top-links-section-title">{section.title}</h2>
    <ul className="footer-top-links-section-list">
      {section.links.map((link) => (
        <li className="footer-top-links-section-list-item" key={link.text}>
          <Link
            className="footer-top-links-section-list-item-link"
            to={link.url}
          >
            {link.text}
          </Link>
        </li>
      ))}
    </ul>
  </div>
));

export const Footer = () => (
  <footer>
    <div className="footer-container">
      <div className="footer-top">
        <div className="footer-top-links">{footerLinkSections}</div>
        <div className="footer-top-contact">
          <Button
            link="mailto:airkeysupport@capitalone.com"
            openInNewTab={true}
            text="Submit Feedback"
          />
          <Button
            link="mailto:airkeysupport@capitalone.com"
            openInNewTab={true}
            text="Support"
          />
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <Link
            className="footer-bottom-left-logo"
            to={EXTERNAL_URLS.DEVELOPER_PORTAL_HOME}
          >
            <AirkeyLogo
              className="navbar-left-airkey-logo"
              aria-hidden="true"
            />
            <p className="footer-bottom-left-logo-title">Developer</p>
          </Link>
          <p className="footer-bottom-left-text">
            © {new Date().getFullYear()} AirKey
          </p>
        </div>
        <div className="footer-bottom-right">
          <div className="footer-bottom-right-links">
            <Link
              className="footer-bottom-right-link"
              to={EXTERNAL_URLS.PRIVACY_POLICY}
            >
              Privacy policy
            </Link>
            <Link
              className="footer-bottom-right-link"
              to={EXTERNAL_URLS.TERMS_AND_CONDITIONS}
            >
              Terms and Conditions
            </Link>
            <Link
              className="footer-bottom-right-link"
              to={EXTERNAL_URLS.IP_NOTICE}
            >
              IP notice
            </Link>
            <Link
              className="footer-bottom-right-link"
              to={EXTERNAL_URLS.PATENTS}
            >
              Patents
            </Link>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
